<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <AdministratorForm
          v-model="user"
          title="Editace administrátora"
          :loading="saving"
          @save="save"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import AdministratorForm from '@/components/forms/AdministratorForm.vue'

export default {
  name: 'AdministratorEdit',
  components: {
    AdministratorForm,
  },
  data() {
    return {
      user: {},
      loading: false,
      saving: false,
    }
  },
  created() {
    this.loadUser()
  },
  methods: {
    ...mapActions({
      getUser: 'user/getUser',
      updateUser: 'user/updateUser',
    }),
    loadUser() {
      this.loading = true
      this.getUser(this.$route.params.id)
        .then((response) => {
          this.user = response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      this.saving = true
      this.updateUser(this.user)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.$router.back()
          }
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>
